
import Accordion from './components/accordion';

window.addEventListener('DOMContentLoaded', () => {
        
new Accordion('.accordion');
const billedV = document.getElementById('billedV');
function setBill(isChecked) {
    if (isChecked) {
        document.body.classList.add('is-billed-monthly');
    } else {
        document.body.classList.remove('is-billed-monthly');
    }
}

billedV.addEventListener('change', function (e) {
    setBill(e.target.checked);
});

let plans = [];

function updateAddons(plan, addOns) {
    const addOnsArray = Array.from(addOns);
    const count = addOnsArray.filter((addOn) =>  {
        return addOn.checked;
    });
    const field = plan.querySelector('.addons-message');
    if (count.length > 0) {
        const plan = (count.length === 1) ? 'plan' : 'plans';
        field.innerHTML = `You have added <strong>${count.length} additional ${plan}</strong>`;
    } else {
        field.innerHTML = ``;
    }
}
const pricingPlans = document.querySelectorAll('.pricing-plan');
if (pricingPlans.length > 0) {
    pricingPlans.forEach((plan, i) => {

        const that = plan;
        const addOns = that.querySelectorAll('.addons input[type="checkbox"]');
        console.log(that);
        addOns.forEach((addOn, i) =>  {
            addOn.addEventListener('change', (e) => {
                updateAddons(that, addOns);
            });
        })
    }); 
}


});